<template>
  <TabsLayout>
    <ElTabPane name="prewarnrules" label="预警管理列表"></ElTabPane>
    <ElTabPane name="prewarnadd" :label="`新增预警规则`" v-if="$route.name === 'prewarnadd'"></ElTabPane>
    <ElTabPane name="prewarnedit" :label="`修改预警规则`" v-if="$route.name === 'prewarnedit'"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  name: 'prewarnrules',
  components: { TabsLayout }
}
</script>
<style lang="scss" scoped></style>
